/* eslint-disable camelcase */
import React from 'react';
import { toast } from 'react-toastify';
import qs from 'qs';
import { actions } from 'react-redux-form';
import ToastMessage from '../components/common/toast-message';
import {
  GET_SUBMISSION_LIST_PENDING,
  GET_SUBMISSION_LIST_REJECTED,
  GET_SUBMISSION_LIST_FETCHED,
  GET_USER_SUBMISSION_LIST_PENDING,
  GET_USER_SUBMISSION_LIST_REJECTED,
  GET_USER_SUBMISSION_LIST_FETCHED,
  GET_USER_SUBMISSION_OVERVIEW_PENDING,
  GET_USER_SUBMISSION_OVERVIEW_REJECTED,
  GET_USER_SUBMISSION_OVERVIEW_FETCHED,
  GET_SUBMISSION_PENDING,
  GET_SUBMISSION_REJECTED,
  GET_SUBMISSION_FETCHED,
  DELETE_SUBMISSION_PENDING,
  DELETE_SUBMISSION_REJECTED,
  DELETE_SUBMISSION_FULFILLED,
  GET_SUBMISSION_META_PENDING,
  GET_SUBMISSION_META_REJECTED,
  GET_SUBMISSION_META_FULFILLED,
  GET_SELL_IT_OBJECTIVES_PENDING,
  GET_SELL_IT_OBJECTIVES_REJECTED,
  GET_SELL_IT_OBJECTIVES_FULFILLED,
  GET_NGP_OBJECTIVES_PENDING,
  GET_NGP_OBJECTIVES_REJECTED,
  GET_NGP_OBJECTIVES_FULFILLED,
  PATCH_SUBMISSION_STATUS_UPDATED_PENDING,
  PATCH_SUBMISSION_STATUS_UPDATED_FULFILLED,
  PATCH_SUBMISSION_STATUS_UPDATED_REJECTED,
  POST_SUBMISSION_RESUBMIT_PENDING,
  POST_SUBMISSION_RESUBMIT_FULFILLED,
  POST_SUBMISSION_RESUBMIT_REJECTED,
  GET_NEXT_AUDIT_SUBMISSION_PENDING,
  GET_NEXT_AUDIT_SUBMISSION_FULFILLED,
  GET_NEXT_AUDIT_SUBMISSION_REJECTED
} from '../reducers/submissionsReducer';
import api from '../irelandApi';
import store, { history } from '../store';
import { destandard, objectToFormData } from '../utils/commonFunctions';

const SUBMISSIONS_URL = 'api/admin/submissions';

export const redirect = () => {
  const { pathname } = store.getState().router.location;
  let path = 'admin';
  if (pathname.includes('team')) {
    path = 'team';
  }
  if (pathname.includes('admin/audit')) {
    path = 'admin/audit';
  }

  history.push(`/${path}/submissions`);
};

const redirectToNextSubmission = () => {
  history.push('/admin/audit/submissions/next');
};

const removeNullFields = (data) => {
  const copy = {...data};

  Object.keys(copy).forEach((key) => {
    if (key === 'audit_completed' && copy[key] !== true) {
      copy[key] = copy[key] || 'false';
    } else {
      copy[key] = copy[key] || '';
    }
  });
  return copy;
};

const prepareSubmissionPayload = (payload) => {
  const submissionsData = removeNullFields(payload);
  const { brand_audit_amounts: audit_amounts, brand_number_of_packs_solds: number_of_packs_solds } = submissionsData;
  submissionsData.submissions_packs_sold_attributes = [];

  if (number_of_packs_solds) {
    const numberOfPacksSolds = number_of_packs_solds.map(numberOfPacksSold => ({
      id: numberOfPacksSold.id,
      submission_id: submissionsData.id,
      brand_id: numberOfPacksSold['brand-id'],
      number_of_packs_sold: numberOfPacksSold.value
    }));

    submissionsData.submissions_packs_sold_attributes.push(...numberOfPacksSolds);
    delete submissionsData.number_of_packs_solds;
  }

  if (audit_amounts) {
    audit_amounts.forEach((auditAmount) => {
      submissionsData.submissions_packs_sold_attributes
        .find(item => item.brand_id === auditAmount['brand-id']).audit_amount = auditAmount.value;
    });

    delete submissionsData.audit_amounts;
  }

  delete submissionsData.decline_reason;
  delete submissionsData.proof_of_purchases;
  submissionsData.proof_of_purchases_attributes = Object.assign({}, ...submissionsData.proof_of_purchases_attributes);

  return objectToFormData(submissionsData, 'submission');
};

export const getSubmissions = (
  outletCode,
  status,
  dateFrom,
  dateTo,
  auditCompleted,
  page = 1,
  submissionType,
  postcodeplanObjectiveId,
  auditorUser
) => (dispatch) => {
  dispatch({ type: GET_SUBMISSION_LIST_PENDING });

  const q = {
    outlet_code: outletCode,
    status,
    upload_date_from: dateFrom,
    upload_date_to: dateTo,
    audit_completed: auditCompleted,
    submission_type: submissionType,
    postcodeplan_objective_id: postcodeplanObjectiveId,
    auditor_user: auditorUser
  };

  return api.get(`/api/admin/submissions?${qs.stringify({ q }, { encodeValuesOnly: true })}&page=${page}`)
    .then((response) => {
      dispatch({
        type: GET_SUBMISSION_LIST_FETCHED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SUBMISSION_LIST_REJECTED,
        payload: error.response
      });
    });
};

export const getUserSubmissions = (
  outlet = null,
  perPage = null
) => (dispatch) => {
  dispatch({ type: GET_USER_SUBMISSION_LIST_PENDING });

  const params = perPage
    ? `?outlet=${outlet}&per_page=${perPage}`
    : `?outlet=${outlet}`;
  return api
    .get(`/api/submissions${params}`)
    .then((response) => {
      dispatch({
        type: GET_USER_SUBMISSION_LIST_FETCHED,
        payload: { data: response.data, outlet }
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_USER_SUBMISSION_LIST_REJECTED,
        payload: error.response
      });
    });
};

export const getUserSubmissionsOverview = outlet => (dispatch) => {
  dispatch({ type: GET_USER_SUBMISSION_OVERVIEW_PENDING });
  return api
    .get(`/api/submissions/submissions_overview?outlet=${outlet}`)
    .then((response) => {
      dispatch({
        type: GET_USER_SUBMISSION_OVERVIEW_FETCHED,
        payload: { outlet, ...response.data }
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_USER_SUBMISSION_OVERVIEW_REJECTED,
        payload: error.response
      });
    });
};

export const getSubmission = id => (dispatch) => {
  dispatch({type: GET_SUBMISSION_PENDING});

  return api.get(`${SUBMISSIONS_URL}/${id}`)
    .then((response) => {
      dispatch({
        type: GET_SUBMISSION_FETCHED,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SUBMISSION_REJECTED,
        payload: error.response
      });
    });
};

export const createSubmission = payload => api.post('api/submissions', prepareSubmissionPayload(destandard(payload)))
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="Submission has been saved successfully"/>);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message={error.response.data.message} />);

    const errorData = error.response ? { ...error.response.data.errors } : {};

    return Promise.reject(errorData);
  });

export const removeSubmission = id => (dispatch) => {
  dispatch({type: DELETE_SUBMISSION_PENDING});
  return api.delete(`${SUBMISSIONS_URL}/${id}`)
    .then(() => {
      dispatch({
        type: DELETE_SUBMISSION_FULFILLED,
        payload: id
      });
    })
    .catch((error) => {
      dispatch({
        type: DELETE_SUBMISSION_REJECTED,
        payload: error.response
      });
    });
};

export const getOutletName = customerNumber => dispatch => api.get(`${SUBMISSIONS_URL}/get_outlet_name?customer_number=${customerNumber}`)
  .then((response) => {
    dispatch(actions.change('deep.admin_submission.outlet_id', response.data.outlet_id));
    dispatch(actions.change('deep.admin_submission.outlet_name', response.data.outlet_name));
  })
  .catch({
  });

export const getSubmissionMeta = () => (dispatch) => {
  dispatch({type: GET_SUBMISSION_META_PENDING});
  return api.get('api/submissions/get_meta')
    .then((response) => {
      dispatch({
        type: GET_SUBMISSION_META_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SUBMISSION_META_REJECTED,
        payload: error.response
      });
    });
};

export const getSellItObjectives = id => (dispatch) => {
  dispatch({type: GET_SELL_IT_OBJECTIVES_PENDING});
  return api.get(`api/outlets/${id}/sell_it_objectives`)
    .then((response) => {
      dispatch({
        type: GET_SELL_IT_OBJECTIVES_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SELL_IT_OBJECTIVES_REJECTED,
        payload: error.response
      });
    });
};

export const getNgpObjectives = id => (dispatch) => {
  dispatch({type: GET_NGP_OBJECTIVES_PENDING});
  return api.get(`api/outlets/${id}/ngp_objectives`)
    .then((response) => {
      dispatch({
        type: GET_NGP_OBJECTIVES_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_NGP_OBJECTIVES_REJECTED,
        payload: error.response
      });
    });
};

export const validateSubmission = (id, payload) =>
  api.patch(`${SUBMISSIONS_URL}/${id}/validate_submission`, prepareSubmissionPayload(destandard({ ...payload, id })))
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Submission has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving submission"/>);

      const errorData = error.response ? error.response.data.errors : [];

      return Promise.reject(errorData);
    })
    .then(() => {
      redirect();
    });

export const declineSubmission = (id, payload) =>
  api.patch(`${SUBMISSIONS_URL}/${id}/decline_submission`, prepareSubmissionPayload(destandard({ ...payload, id })))
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Submission has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving submission"/>);

      const errorData = error.response ? error.response.data.errors : [];

      return Promise.reject(errorData);
    })
    .then(() => {
      if (store.getState().router.location.pathname.match('admin/audit/submissions/')) {
        redirectToNextSubmission();
      } else {
        redirect();
      }
    });

export const updateSubmission = (id, payload) =>
  api.patch(`${SUBMISSIONS_URL}/${id}`, prepareSubmissionPayload(destandard({ ...payload, id })))
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Submission has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving submission"/>);

      const errorData = error.response ? error.response.data.errors : [];

      return Promise.reject(errorData);
    })
    .then(() => {
      redirect();
    });

export const updateSubmissionsStatus = (type, submissionIds) => (dispatch) => {
  dispatch({ type: PATCH_SUBMISSION_STATUS_UPDATED_PENDING });

  return api.patch(`${SUBMISSIONS_URL}/update_status_${type}`, submissionIds)
    .then((response) => {
      dispatch({
        type: PATCH_SUBMISSION_STATUS_UPDATED_FULFILLED,
        payload: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Submissions have been updated successfully" />);
    })
    .catch((error) => {
      dispatch({
        type: PATCH_SUBMISSION_STATUS_UPDATED_REJECTED,
        payload: error.response
      });
      toast.error(<ToastMessage iconStyle="error" message="Error while updating submissions" />);
    })
    .then(() => {
      redirect();
    });
};

export const resubmitSubmissions = submissionId => (dispatch) => {
  dispatch({ type: POST_SUBMISSION_RESUBMIT_PENDING });

  return api.post(`${SUBMISSIONS_URL}/${submissionId}/resubmit`)
    .then((response) => {
      dispatch({
        type: POST_SUBMISSION_RESUBMIT_FULFILLED,
        payload: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Submission have been resubmitted successfully" />);
    })
    .catch((error) => {
      dispatch({
        type: POST_SUBMISSION_RESUBMIT_REJECTED,
        payload: error.response
      });
      toast.error(<ToastMessage iconStyle="error" message="Error while resubmit" />);
    })
    .then(() => {
      redirect();
    });
};

export const internalEnquirySubmission = (id, payload) =>
  api.patch(`${SUBMISSIONS_URL}/${id}/internal_enquiry`, prepareSubmissionPayload(destandard({ ...payload, id })))
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Submission status has been updated successfully"/>);

      redirectToNextSubmission();
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving submission status"/>);

      const errorData = error.response ? error.response.data.errors : [];

      return Promise.reject(errorData);
    });

export const repEnquirySubmission = (id, payload) =>
  api.patch(`${SUBMISSIONS_URL}/${id}/rep_enquiry`, prepareSubmissionPayload(destandard({ ...payload, id })))
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Submission status has been updated successfully"/>);

      redirectToNextSubmission();
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving submission status"/>);

      const errorData = error.response ? error.response.data.errors : [];

      return Promise.reject(errorData);
    });

export const itukEnquirySubmission = (id, payload) =>
  api.patch(`${SUBMISSIONS_URL}/${id}/ituk_enquiry`, prepareSubmissionPayload(destandard({ ...payload, id })))
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Submission status has been updated successfully"/>);

      redirectToNextSubmission();
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving submission status"/>);

      const errorData = error.response ? error.response.data.errors : [];

      return Promise.reject(errorData);
    });

export const auditorValidateSubmission = (id, payload) =>
  api.patch(`${SUBMISSIONS_URL}/${id}/auditor_validate`, prepareSubmissionPayload(destandard({ ...payload, id })))
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Submission has been validated successfully"/>);

      redirectToNextSubmission();
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving submission status"/>);

      const errorData = error.response ? error.response.data.errors : [];

      return Promise.reject(errorData);
    });

export const getNextAuditSubmission = () => (dispatch) => {
  dispatch({ type: GET_NEXT_AUDIT_SUBMISSION_PENDING });
  store.dispatch(actions.reset('deep.admin_submission'));
  api.get(`${SUBMISSIONS_URL}/next_audit_submission`)
    .then((response) => {
      dispatch({
        type: GET_NEXT_AUDIT_SUBMISSION_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_NEXT_AUDIT_SUBMISSION_REJECTED,
        payload: error.response
      });
    });
};

export const checkReceiptIdUniqueness = (id, receiptId) =>
  api.get(`${SUBMISSIONS_URL}/${id}/check_receipt_id_uniqueness?receipt_id=${receiptId}`)
    .then(response => response.data.receipt_id_unique)
    .catch(() => false);



// WEBPACK FOOTER //
// ./src/actions/submissions.js